import { render, staticRenderFns } from "./FacebookIcon.vue?vue&type=template&id=54c91bf9&functional=true&"
var script = {}
import style0 from "./FacebookIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\adviewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c91bf9')) {
      api.createRecord('54c91bf9', component.options)
    } else {
      api.rerender('54c91bf9', component.options)
    }
    module.hot.accept("./FacebookIcon.vue?vue&type=template&id=54c91bf9&functional=true&", function () {
      api.rerender('54c91bf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/FacebookIcon.vue"
export default component.exports